export type EditorEntityProps = Record<string, string|number|boolean>;

export enum EditorEntityType
    {
    SEGMENT = 'SegmentEntity',
    VERT = 'VertEntity',
    SPRITE = 'SpriteEntity',
    TRIGGER = 'TriggerEntity',
}

export interface EditorEntityData
{
    type: EditorEntityType
    x: number,
    y: number,
    props?: EditorEntityProps
}

export interface EditorData
{
    name: string,
    groundLoop: string,
    groundConveyorLoop: string,
    groundSlimeLoop: string,
    frontGrass: string[],
    frontFlowers: string[],
    backGrass: string[],
    backBushes: string[],
    groundJunction: string,
    entities: EditorEntityData[]
    scale?: number,
}

export interface EditorSpriteData extends EditorEntityData
{
    w: number,
    h: number,
    sx: number,
    sy: number,
    r: number,
    img: string,
    repeat?: number,
}

export interface EditorVertData extends EditorEntityData
{
    cx: number,
    cy: number
}

export interface EditorSegmentData extends EditorEntityData
{
    w: number,
    h: number,
    thickness: number,
    precision: number,
    baseline: number,
    img: string,
    verts: EditorVertData[],
}

export interface EditorTriggerData extends EditorEntityData
{
    w: number,
    h: number,
    r: number,
}

export class EditorUtils
{
    public static scaleData(data: EditorData, scale = 0.5): void
    {
        if (data.scale) return;
        data.scale = scale;
        for (const entity of data.entities)
        {
            const en = entity as any;

            if (en.x !== undefined) en.x = this.scaleNumber(en.x, scale);
            if (en.y !== undefined) en.y = this.scaleNumber(en.y, scale);
            if (en.w !== undefined) en.w = this.scaleNumber(en.w, scale);
            if (en.h !== undefined) en.h = this.scaleNumber(en.h, scale);
            if (en.thickness !== undefined) en.thickness = this.scaleNumber(en.thickness, scale);
            if (en.verts)
            {
                for (const vert of en.verts)
                {
                    if (vert.x !== undefined) vert.x = this.scaleNumber(vert.x, scale);
                    if (vert.y !== undefined) vert.y = this.scaleNumber(vert.y, scale);
                    if (vert.cx !== undefined) vert.cx = this.scaleNumber(vert.cx, scale);
                    if (vert.cy !== undefined) vert.cy = this.scaleNumber(vert.cy, scale);
                }
            }
        }
    }

    private static scaleNumber(v: number, scale: number)
    {
        return Number((v * scale).toPrecision(4));
    }
}
